import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setContinueButtonText } from 'store/CustomReports/actions'
import { resetSelectedLocations } from 'store/CustomReports/actions'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { setCourseLocationAndLocationGroups } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'
import { SlideHeader } from './SlideHeader'
import Search from './Search'
import FilterSelectedOnly from './FilterSelectedOnly'
import { setSelectedLocations } from 'store/CustomReports/actions'
import { NavLink } from 'reactstrap'
import _ from 'lodash'
import { setCourseGroupLocationAndLocationGroups } from 'store/CustomReports/actions'

export default function LocationFiltering({ locations, locationGroups }) {
  const dispatch = useDispatch()
  const {
    selectedLocations: { locations: selectedLocations, type },
    showSelectedOnly,
    editingReport,
    selectedReportType,
  } = useSelector((store) => store.customReports)

  const [filteredLocations, setFilteredLocations] = useState([])

  const [searchValue, setSearchValue] = useState('')
  const [activeTab, setActiveTab] = useState(0)

  const changeTab = (tab) => {
    setActiveTab(tab)
    setSearchValue('')
  }

  useEffect(() => {
    if (selectedReportType === 0) {
      dispatch(setCourseLocationAndLocationGroups())
    } else {
      dispatch(setCourseGroupLocationAndLocationGroups())
    }
  }, [dispatch, selectedReportType])

  useEffect(() => {
    if (activeTab === 0) {
      setFilteredLocations(
        locations?.length
          ? locations.filter((location) =>
              location.name
                .toLowerCase()
                .includes(searchValue.trim().toLowerCase())
            )
          : []
      )
    }

    if (activeTab === 1) {
      setFilteredLocations(
        locationGroups?.length
          ? locationGroups.filter((location) =>
              location.name
                .toLowerCase()
                .includes(searchValue.trim().toLowerCase())
            )
          : []
      )
    }
  }, [searchValue, activeTab, locations, locationGroups])

  useEffect(() => {
    if (editingReport) {
      if (
        _.isEqual(
          _.sortBy(locations.map((location) => location.id)),
          _.sortBy(selectedLocations)
        )
      ) {
        dispatch(resetSelectedLocations())
      }
    }
  }, [editingReport, locations, selectedLocations, dispatch])

  useEffect(() => {
    wait(() => {
      dispatch(setContinueDisabled(false))
      if (!selectedLocations?.length) {
        dispatch(setContinueButtonText('Skip'))
      } else {
        dispatch(setContinueButtonText('Continue'))
      }
    })
  }, [dispatch, selectedLocations?.length])

  return (
    <>
      <SlideHeader
        header='Filter by Locations or Location Groups'
        helper='(Not adding any filters will simply apply all locations)'
      />

      <div className='border p-4 mx-auto single-course-container scrollbar'>
        <div className='d-flex align-items-center mb-4'>
          <div className='settings-tabs switch-tabs mx-auto d-flex py-1 mb-0'>
            <NavLink
              activeClassName='current'
              className={activeTab === 0 ? 'current' : ''}
              onClick={() => changeTab(0)}
            >
              Locations
            </NavLink>
            <NavLink
              activeClassName='current'
              className={activeTab === 1 ? 'current' : ''}
              onClick={() => changeTab(1)}
            >
              Location Groups
            </NavLink>
          </div>
          <Search
            placeholder={
              activeTab === 0
                ? 'Search for a location'
                : 'Search for a location group'
            }
            value={searchValue}
            setValue={setSearchValue}
            width='w-50'
            marginBottom='mb-0'
          />
        </div>
        <FilterSelectedOnly items={selectedLocations} />
        {filteredLocations && filteredLocations.length
          ? filteredLocations.map((location) => {
              const isSelected = selectedLocations.includes(location.id)
              return (
                <div
                  key={location.id}
                  className={`custom-control custom-checkbox mb-3 ${
                    !isSelected && showSelectedOnly && 'd-none'
                  }`}
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={location.id}
                    className='custom-control-input'
                    id={location.id}
                    checked={isSelected}
                    onChange={(e) => {
                      if (selectedLocations.length) {
                        if (type !== activeTab)
                          dispatch(resetSelectedLocations())
                      }
                      dispatch(setSelectedLocations(+e.target.value, activeTab))
                    }}
                    type='checkbox'
                  />
                  <label className='custom-control-label' htmlFor={location.id}>
                    {location.name}
                  </label>
                </div>
              )
            })
          : null}
      </div>
    </>
  )
}
